import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { UserLevel, userLevelFromString, userLevelIsEnough } from '@app/core/models/user-level';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

/**
 * Structural directive `*portalHasRole="'RoleAsString'"` will render the DOM element if the authenticated user has the role.
 * See for `UserLevel` in `src/app/core/models/user-level.ts` to find valid values for user roles.
 */
@UntilDestroy()
@Directive({
  selector: '[portalHasRole]',
  standalone: false,
})
export class HasRoleDirective {
  private userLevel: UserLevel;

  @Input('portalHasRole')
  set portalIfLevel(rawLevel: string) {
    this.userLevel = userLevelFromString(rawLevel);
  }

  @Input()
  portalHasRoleElse?: TemplateRef<any>;

  constructor(
    private authService: AuthenticationService,
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.authService.authUser$.pipe(untilDestroyed(this)).subscribe((user) => {
      // If not cleared it could happen that some elements are displayed multiple times
      this.viewContainer.clear();

      if (userLevelIsEnough(this.userLevel, user)) {
        this.viewContainer.createEmbeddedView(this.template);
      } else if (this.portalHasRoleElse) {
        this.viewContainer.createEmbeddedView(this.portalHasRoleElse);
      }
    });
  }
}
